import type { FC } from 'react';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import { Input } from '@ui';
import OrderRegisterCustomMap from '@components/OrderRegistration/components/OrderRegisterCustomMap';
import useWindowSize from '@customHooks/useWindowSize';
import DeliveryTypeToggle from '../components/DeliveryTypeToggle';
import ModalHeader from '../components/ModalHeader';
import type { MapState } from '../types';

interface DeliveryStageProps {
  isHideDelivery?: boolean;
  mapState: MapState;
  onChangeType: (id: number) => () => void;
  closeModal: () => void;
  onSubmit: () => void;
}

const DeliveryStage: FC<DeliveryStageProps> = observer(
  ({ isHideDelivery, mapState, onChangeType, closeModal, onSubmit }) => {
    const { isMobile } = useWindowSize();
    const {
      mapRef,
      onMapClick,
      onLoadMap,
      coordsN,
      editAddress,
      iconContentTemplate,
      address,
      isDefaultMark,
      selectedAddress,
      selectAddress,
      onSelectDaData,
      balloonState
    } = mapState;

    const addressErrorText = !isEmpty(balloonState)
      ? 'Укажите номер дома либо подтвердите на карте'
      : '';

    const mapProps = {
      mapRef,
      onMapClick,
      onLoadMap,
      coords: coordsN,
      editAddress,
      iconContentTemplate,
      isShowMapMarkPlace: true,
      isDefaultMark,
      selectedAddress,
      selectAddress,
      mapRefName: 'mapRef' as const,
      isShowClusterer: false
    };

    return (
      <>
        <div className='left'>
          <div className='desktop'>
            {!isHideDelivery && (
              <DeliveryTypeToggle
                isPickupCart={false}
                onChangeType={onChangeType}
              />
            )}

            <div className='regionTitle'>
              <span className='title'>
                {isHideDelivery ? 'Выберите пункт выдачи' : 'Укажите ваш адрес'}
              </span>
            </div>

            <Input
              classNameParent='order-page-input'
              classNameInput='custom-input'
              placeHolder='Поиск'
              value={address}
              field='address'
              onFocus={() => {}}
              onBlur={() => {}}
              inputType='text'
              onSelectDaData={onSelectDaData}
              isAddressError={!isEmpty(balloonState)}
              addressErrorText={addressErrorText}
              isNewStyleSearch
            />

            <div className='description'>
              Введите адрес, выберете из списка или на карте. Покажем наличие
              товаров и актуальные условия доставки
            </div>

            {address ? <div className='homeTitle'>{address}</div> : null}
          </div>

          <div className='header-info'>
            <ModalHeader title='Укажите ваш адрес' onClose={closeModal} />

            <div className='description'>
              Покажем наличие товаров и условия доставки
            </div>

            <Input
              classNameParent='order-page-input'
              classNameInput='custom-input'
              placeHolder='Поиск'
              value={address}
              field='address'
              onFocus={() => {}}
              onBlur={() => {}}
              inputType='text'
              onSelectDaData={onSelectDaData}
              isAddressError={!isEmpty(balloonState)}
              addressErrorText={addressErrorText}
            />
          </div>

          {isMobile && (
            <div className='body-info'>
              <OrderRegisterCustomMap
                {...mapProps}
                width='100vw'
                height='100%'
              />
            </div>
          )}

          <div className='footer-info'>
            <div className='mobile-info'>
              {!isHideDelivery && (
                <DeliveryTypeToggle
                  isPickupCart={false}
                  onChangeType={onChangeType}
                />
              )}

              {address ? <div className='homeTitle'>{address}</div> : null}
            </div>
            <div onClick={onSubmit} className='confirm-modal'>
              Подтвердить
            </div>
          </div>
        </div>

        {!isMobile && (
          <div className='right'>
            <OrderRegisterCustomMap {...mapProps} width='500px' height='540px' />
          </div>
        )}
      </>
    );
  }
);

export default DeliveryStage;
